export default {
  title: 'MRR-rapport',
  fields: {
    name: 'Navn',
    area: 'Område',
    mrr: 'MRR (netto)',
  },
  buttons: {
    download_report: 'Download rapport',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses, opdater siden',
  },
};
